import {
  DEFAULT_COLOR_GRAY,
  DEFAULT_MARKDOWN_PLACEHOLDER,
  DEFAULT_COLOR_PRIMARY,
  DEFAULT_JOB,
  DEFAULT_AVATAR,
  DEFAULT_COLOR_WHITE,
  DEFAULT_REVIEW_TEXT,
  DEFAULT_NAME,
} from '../constants'
import { baseSchemaProperties } from '../base-schema-properties'
import { titleSchemaProperties } from '../common'

export default {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Reviews',
  description: "Cards with user's avatar, name, company and review text",
  type: 'object',
  required: ['colsNumberOnDesktop', 'colsNumberOnMobile'],
  properties: {
    ...baseSchemaProperties,
    ...titleSchemaProperties,
    tmp_showColorSettings: {
      title: 'Show color settings',
      type: 'boolean',
      default: false,
    },
    bgColor: {
      title: 'Block Background Color',
      type: 'string',
      default: DEFAULT_COLOR_WHITE,
      'ui:hidden': '{{ parentFormData.tmp_showColorSettings === false}}',
    },
    cardBgColor: {
      title: 'Card Background Color',
      type: 'string',
      default: '#f0f6ff',
      'ui:hidden': '{{ parentFormData.tmp_showColorSettings === false}}',
    },
    iframeCardBgColor: {
      title: 'Iframe Card Background Color',
      type: 'string',
      default: '#f0f6ff',
      'ui:hidden': '{{ parentFormData.tmp_showColorSettings === false}}',
    },
    userInfoColor: {
      title: 'Cards User Info Color',
      type: 'string',
      default: DEFAULT_COLOR_GRAY,
      'ui:hidden': '{{ parentFormData.tmp_showColorSettings === false}}',
    },
    iframeUserInfoColor: {
      title: 'Iframe Cards User Info Color',
      type: 'string',
      default: DEFAULT_COLOR_GRAY,
      'ui:hidden': '{{ parentFormData.tmp_showColorSettings === false}}',
    },
    textColor: {
      title: 'Cards Text Color',
      type: 'string',
      default: DEFAULT_COLOR_GRAY,
      'ui:hidden': '{{ parentFormData.tmp_showColorSettings === false}}',
    },
    iframeTextColor: {
      title: 'Iframe Cards Text Color',
      type: 'string',
      default: DEFAULT_COLOR_GRAY,
      'ui:hidden': '{{ parentFormData.tmp_showColorSettings === false}}',
    },
    iframeLinkColor: {
      title: 'Iframe Link Color',
      type: 'string',
      default: DEFAULT_COLOR_PRIMARY,
      'ui:hidden': '{{ parentFormData.tmp_showColorSettings === false}}',
    },
    reviews: {
      type: 'array',
      title: 'A list of reviews',
      'ui:options': {
        showIndexNumber: true,
      },
      items: {
        title: 'Review',
        type: 'object',
        required: ['name', 'company', 'text'],
        properties: {
          name: {
            title: 'Name',
            type: 'string',
            default: DEFAULT_NAME,
          },
          company: {
            title: 'Company',
            type: 'string',
            default: DEFAULT_JOB,
          },
          image: {
            title: 'Image url',
            type: 'string',
            default: DEFAULT_AVATAR,
          },
          text: {
            title: 'Review text',
            type: 'string',
            'ui:options': {
              placeholder: DEFAULT_MARKDOWN_PLACEHOLDER,
              type: 'textarea',
              rows: 6,
            },
            default: DEFAULT_REVIEW_TEXT,
          },
        },
      },
    },
  },
}
